module.exports = __webpack_public_path__ + "img/20210906-1630898372667167.ceb5c00e.jpg";